import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-eye',
  imports: [],
  templateUrl: './eye.html',
  styleUrl: './eye.scss',
})
export class Eye {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
